import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import pedagogieStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'pedagogie'
const customImplement: CustomStoreImplementationOptions = pedagogieStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function pedagogieFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('pedagogie-matchers.title', 'Notre pédagogie | Matchers'),
        $description: $translate('pedagogie-matchers.description', 'La pédagogie Matchers a un objectif : proposer des formations vraiment utiles en étant au service d\'un projet concret ! Découvrez une méthodologie adaptée aux petites entreprises. '),
        $publishedTime: new Date('2023-04-05T08:08:41.023Z'),
        $modifiedTime: new Date('2023-08-17T10:12:48.786Z'),
        // Constants,
        $constants: {
          graceALaReforme: 'Grâce à la réforme de la formation professionnelle de 2018, de nouvelles méthodes d\'apprentissage ont pu voir le jour et notamment le <strong>learning in the flow of work </strong>(LIFOW). <br> <br>"<strong>Apprendre dans le flux de travail</strong>". Cette approche change totalement le rapport entre formation et travail. Ils ne sont plus déconnectés, au contraire, ils s’associent. Le salarié se forme tout en restant en lien avec la tâche qu’il est en train d’effectuer. Grâce à cette méthode, Matchers propose des temps de formation qui ne s’étendent plus sur plusieurs heures mais des sessions <strong>brèves</strong> et <strong>fréquentes</strong>. ',
          dailleursLeMot: 'D\'ailleurs, le mot <i>expert</i> n’a pas été choisi au hasard. <br><span style=\'background-color:transparent;color:#AFAFAFFF;\'><i>"Qui a acquis une grande habileté par l\'expérience, par la pratique".</i></span>',
          text5: '"',
          text7: '"'
        },
        // Data,
        $info: { pedagogieMatchers: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      imageClick () {
        openUrl('https://www.matchers.fr/expert/194', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image1Click () {
        openUrl('https://www.matchers.fr/expert/398', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      prendreRendezVousClick () {
        openUrl('https://meetings.hubspot.com/christophe-pramil', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image2Click () {
        openUrl('https://www.matchers.fr/expert/288', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image3Click () {
        openUrl('https://www.matchers.fr/expert/622', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image4Click () {
        openUrl('https://www.matchers.fr/expert/247', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image5Click () {
        openUrl('https://www.matchers.fr/expert/195', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image6Click () {
        openUrl('https://www.matchers.fr/expert/135', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image8Click () {
        openUrl('https://www.matchers.fr/expert/306', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image9Click () {
        openUrl('https://www.matchers.fr/expert/274', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image10Click () {
        openUrl('https://www.matchers.fr/expert/158', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image11Click () {
        openUrl('https://www.matchers.fr/expert/265', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image12Click () {
        openUrl('https://www.matchers.fr/expert/241', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image13Click () {
        openUrl('https://www.matchers.fr/expert/342', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      image14Click () {
        openUrl('https://www.matchers.fr/expert/342', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return pedagogieFactory(storeId)()
}

export const pedagogieRaw = pedagogieFactory()
export const pedagogie = () => pedagogieRaw() as MergeCustomStore<typeof pedagogieStoreCustom.instance>
